import { getTargetingDe } from '../../helpers/targeting/de/getTargetingDe';
export const configuration = {
    targeting: {
        // TODO: Do we need specific targeting for immowelt.at or the German one can be used?
        getTargeting: getTargetingDe,
        fetchHierarchy: true,
    },
};
